import Cookies from 'universal-cookie';

const cookies = new Cookies(null, { path: '/' });

export function getIsPrepaidCardBalanceUpdated(): boolean {
    return cookies.get('prepaidCardUpdated', { doNotParse: true }) === 'true';
}

export function setIsPrepaidCardBalanceUpdated(value: boolean) {
    cookies.set('prepaidCardUpdated', value ? 'true' : 'false', {
        maxAge: 300,
        path: '/',
    });
}
